import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { Observable } from 'rxjs';

import {
    BaseNestedFieldDefinition,
    ComplexMapFieldValue,
    ExtendedBaseProfileField,
    FieldDefinitionHelper,
    FieldReadHelper,
    FieldValue,
    FormValue,
    PartialRecord,
    ShComplexInputFieldComponent
} from '@stylehaven/components';
import {
    WebserviceConfig,
    WebserviceConfigJson
} from '../../../../external-webservice/entities/webservice-config.entity';

@Component({
    selector: 'med-webservice-list-input-field',
    templateUrl: './webservice-list-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WebserviceListInputFieldComponent extends ShComplexInputFieldComponent {
    public fieldDefinitions$: Observable<BaseNestedFieldDefinition[]>;
    public webserviceConfig: WebserviceConfig;
    public multiple: boolean;

    constructor(fieldHelper: FieldReadHelper, @Inject('config') config: WebserviceConfigJson) {
        super(fieldHelper);

        this.webserviceConfig = new WebserviceConfig(config);
    }

    init(profileField: ExtendedBaseProfileField, fragments: PartialRecord[], control: UntypedFormControl): void {
        this.multiple = FieldDefinitionHelper.IsList(profileField.FieldDefinition);

        const values: FormValue<ComplexMapFieldValue>[] = this.fieldHelper.getMergedComplexFieldValue(
            profileField.FieldDefinition,
            fragments
        );

        const filtered: FormValue<FieldValue>[] = values.filter(formValue => !!formValue.value);
        control.setValue(filtered);
    }
}
